var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { selectBallotStyleByElectionId } from "../store/ballotStyles/ballotStylesSlice";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { store } from "../store/store";
import { Box } from "@mui/material";
import { PageLimit, Icon, IconButton, theme, Dialog, VisuallyHidden } from "@sequentech/ui-essentials";
import { check_voting_error_dialog_bool, check_voting_not_allowed_next_bool, checkIsBlank, stringToHtml, isUndefined, translateFromPresentation, EElectionEventContestEncryptionPolicy, EBlankBallotsPolicy, getDefaultVotingScreenBackPolicy, areAllContestsAcclaimed, getContestClassName, isAcclaimedContest, } from "@sequentech/ui-core";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { faCircleQuestion, faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import { redirect, useLocation, useNavigate, useParams, useSubmit } from "react-router-dom";
import { selectBallotSelectionByElectionId, resetBallotSelection, setAllBallotSelectionsBlankBallot, } from "../store/ballotSelections/ballotSelectionsSlice";
import { clearDeclinedToVoteForElection, clearIsVoted, setIsVoted } from "../store/extra/extraSlice";
import { provideBallotService } from "../services/BallotService";
import { Question, contestTitleId } from "../components/Question/Question";
import { CircularProgress } from "@mui/material";
import { selectElectionById } from "../store/elections/electionsSlice";
import { useRootBackLink } from "../hooks/root-back-link";
import { VotingPortalError, VotingPortalErrorType } from "../services/VotingPortalError";
import Stepper from "../components/Stepper";
import { AuthContext } from "../providers/AuthContextProvider";
import { canVoteSomeElection } from "../store/castVotes/castVotesSlice";
import { sortContestList } from "@sequentech/ui-core";
import { useEncryptBallotForReview } from "../hooks/useEncryptBallotForReview";
import { useBallotStyleSlates } from "../hooks/useBallotStyleSlates";
import { BallotSlatesProvider } from "../providers/BallotSlatesProvider";
import { SlateSelectionChooser } from "../components/SlateChooser/SlateSelectionChooser";
import { ESlateBallotTab, SlateBallotTabs } from "../components/SlateChooser/SlateBallotTabs";
import { SlateOfficeNavigator } from "../components/SlateChooser/SlateOfficeNavigator";
import { SlateBallotCount, SlateSelectionLabel } from "../components/SlateChooser/SlateBallotSummary";
import { useSlateClear } from "../components/SlateChooser/SlateClearFlow";
import { getEditContestId } from "../services/EditContest";
import { sortContestsInBallotOrder } from "../services/ContestOrder";
var StyledTitle = styled(Typography)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-top: 25.5px;\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n    font-size: 36px;\n    justify-content: center;\n"], ["\n    margin-top: 25.5px;\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n    font-size: 36px;\n    justify-content: center;\n"])));
var ActionsContainer = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    margin-bottom: 20px;\n    margin-top: 10px;\n    gap: 2px;\n"], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    margin-bottom: 20px;\n    margin-top: 10px;\n    gap: 2px;\n"])));
var StyledButton = styled(Button)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display flex;\n    padding: 5px;\n\n    span {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        padding: 5px;\n    }\n"], ["\n    display flex;\n    padding: 5px;\n\n    span {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        padding: 5px;\n    }\n"])));
var ActionButtons = function (_a) {
    var _b, _c;
    var handleNext = _a.handleNext, handlePrev = _a.handlePrev, handleClearCustom = _a.handleClearCustom, pageIndex = _a.pageIndex, disableNext = _a.disableNext, disableClear = _a.disableClear;
    var t = useTranslation().t;
    var backLink = useRootBackLink();
    var _d = useParams(), tenantId = _d.tenantId, eventId = _d.eventId, electionId = _d.electionId;
    var location = useLocation();
    var navigate = useNavigate();
    var election = useAppSelector(selectElectionById(String(electionId)));
    var ballotStyle = useAppSelector(selectBallotStyleByElectionId(String(electionId)));
    var dispatch = useAppDispatch();
    var votingScreenBackPolicy = (_c = (_b = election === null || election === void 0 ? void 0 : election.presentation) === null || _b === void 0 ? void 0 : _b.voting_screen_back_policy) !== null && _c !== void 0 ? _c : getDefaultVotingScreenBackPolicy();
    var exitLink = votingScreenBackPolicy === "start-screen"
        ? "/tenant/".concat(tenantId, "/event/").concat(eventId, "/election/").concat(electionId, "/start").concat(location.search)
        : "".concat(backLink).concat(location.search);
    function handleClear() {
        if (ballotStyle) {
            dispatch(resetBallotSelection({
                ballotStyle: ballotStyle,
                force: true,
            }));
            dispatch(clearIsVoted());
        }
    }
    return (_jsxs(_Fragment, { children: [_jsx(StyledButton, { className: "clear-selection-button", sx: {
                    display: { sm: "none" },
                    width: "100%",
                }, variant: "secondary", onClick: function () { return (handleClearCustom ? handleClearCustom() : handleClear()); }, disabled: disableClear, children: _jsx(Box, { className: "clear-selection-label", children: t("votingScreen.clearButton") }) }), _jsxs(ActionsContainer, { className: "actions-container", children: [_jsxs(StyledButton, { className: "back-button", sx: { margin: "auto 0", width: { xs: "100%", sm: "200px" } }, onClick: function () {
                            handlePrev();
                            if (!pageIndex || pageIndex <= 0) {
                                navigate(exitLink);
                            }
                        }, children: [_jsx(Icon, { className: "back-button-icon", icon: faAngleLeft, size: "sm" }), _jsx(Box, { className: "back-button-label", children: t("votingScreen.backButton") })] }), _jsx(StyledButton, { className: "clear-selection-button", sx: {
                            display: { xs: "none", sm: "block" },
                            width: { xs: "100%", sm: "200px" },
                        }, variant: "secondary", onClick: function () { return (handleClearCustom ? handleClearCustom() : handleClear()); }, disabled: disableClear, children: _jsx(Box, { className: "clear-selection-label", children: t("votingScreen.clearButton") }) }), _jsxs(StyledButton, { className: "next-button", sx: { width: { xs: "100%", sm: "200px" } }, onClick: function () { return handleNext(); }, disabled: disableNext, children: [_jsx(Box, { className: "next-button-label", children: t("votingScreen.reviewButton") }), _jsx(Icon, { className: "next-button-icon", icon: faAngleRight, size: "sm" })] })] })] }));
};
var ContestPagination = function (_a) {
    var _b, _c;
    var ballotStyle = _a.ballotStyle, contests = _a.contests, onSetDisableNext = _a.onSetDisableNext, onSetDecodedContests = _a.onSetDecodedContests, encryptAndReview = _a.encryptAndReview, disableNextButton = _a.disableNextButton, slateChooser = _a.slateChooser, slateCount = _a.slateCount, slateLabel = _a.slateLabel, slateTab = _a.slateTab, onSlateTabChange = _a.onSlateTabChange, officeRequest = _a.officeRequest, editContestId = _a.editContestId;
    var dispatch = useAppDispatch();
    var submit = useSubmit();
    var t = useTranslation().t;
    var contestsOrderType = (_b = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml.election_presentation) === null || _b === void 0 ? void 0 : _b.contests_order;
    var _d = useState(0), pageIndex = _d[0], setPageIndex = _d[1];
    var pageAnnouncementRef = useRef(null);
    // A ballot with slates is cleared as a whole, after the voter sees what goes.
    var slateClear = useSlateClear(ballotStyle);
    var isFirstRender = useRef(true);
    useEffect(function () {
        var _a;
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        (_a = pageAnnouncementRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [pageIndex]);
    // The review screen sends the voter back to edit one contest: its page is
    // opened and its heading takes the focus.
    var isEditContestShown = useRef(false);
    var _e = useState(0), office = _e[0], setOffice = _e[1];
    var sortedContests = sortContestList(contests[pageIndex], contestsOrderType);
    useEffect(function () {
        var requested = (sortedContests !== null && sortedContests !== void 0 ? sortedContests : []).findIndex(function (contest) { return contest.id === (officeRequest === null || officeRequest === void 0 ? void 0 : officeRequest.contestId); });
        if (requested >= 0) {
            setOffice(requested);
        }
    }, [officeRequest]);
    useEffect(function () {
        if (!editContestId || isEditContestShown.current) {
            return;
        }
        var editPageIndex = contests.findIndex(function (page) {
            return page.some(function (contest) { return contest.id === editContestId; });
        });
        if (editPageIndex < 0) {
            return;
        }
        if (editPageIndex !== pageIndex) {
            setPageIndex(editPageIndex);
            return;
        }
        var editOffice = (sortedContests !== null && sortedContests !== void 0 ? sortedContests : []).findIndex(function (contest) { return contest.id === editContestId; });
        if (slateChooser && editOffice >= 0 && editOffice !== office) {
            setOffice(editOffice);
            return;
        }
        isEditContestShown.current = true;
        var title = document.getElementById(contestTitleId(editContestId));
        if (title) {
            title.tabIndex = -1;
            title.focus();
        }
    }, [contests, pageIndex, editContestId, office, sortedContests, slateChooser]);
    var ballotSelectionState = useAppSelector(selectBallotSelectionByElectionId(ballotStyle.election_id));
    var _f = provideBallotService(), interpretContestSelection = _f.interpretContestSelection, interpretMultiContestSelection = _f.interpretMultiContestSelection;
    var isMultiContest = ((_c = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml.election_event_presentation) === null || _c === void 0 ? void 0 : _c.contest_encryption_policy) ===
        EElectionEventContestEncryptionPolicy.MULTIPLE_CONTESTS;
    var errorSelectionState = useMemo(function () {
        if (!ballotSelectionState) {
            return [];
        }
        var selectionState = [];
        try {
            if (isMultiContest) {
                selectionState = interpretMultiContestSelection(ballotSelectionState, ballotStyle.ballot_eml);
            }
            else {
                selectionState = interpretContestSelection(ballotSelectionState, ballotStyle.ballot_eml);
            }
        }
        catch (err) {
            console.log("Error was thrown by wasm interface: ", err);
            submit({ error: VotingPortalErrorType.UNABLE_TO_ENCRYPT_BALLOT }, { method: "post" });
        }
        return selectionState;
    }, [ballotSelectionState, isMultiContest, ballotStyle.ballot_eml]);
    var handleNext = function () {
        // The contests of the later pages are only checked once they are
        // shown, so a ballot with several pages goes through them.
        if (slateChooser && slateTab === ESlateBallotTab.SLATES && contests.length > 1) {
            onSlateTabChange(ESlateBallotTab.CANDIDATES);
        }
        else if (pageIndex === contests.length - 1) {
            encryptAndReview();
        }
        else {
            setPageIndex(pageIndex + 1);
        }
    };
    var handlePrev = function () {
        if (pageIndex > 0) {
            setPageIndex(pageIndex - 1);
        }
        else {
            dispatch(clearIsVoted());
        }
    };
    function handleClear() {
        if (ballotStyle) {
            contests[pageIndex].forEach(function (contest) {
                dispatch(resetBallotSelection({
                    ballotStyle: ballotStyle,
                    force: true,
                    contestId: contest.id,
                }));
            });
            if (pageIndex === 0)
                dispatch(clearIsVoted());
        }
    }
    var renderContest = function (contest, index) { return (_jsx(Box, { className: "contest-container contest-".concat(index, " ").concat(getContestClassName(contest.external_id)).trim(), children: _jsx(Question, { ballotStyle: ballotStyle, question: contest, isReview: false, setDisableNext: function () { return onSetDisableNext(contest.id); }, setDecodedContests: onSetDecodedContests(contest.id), errorSelectionState: errorSelectionState }) }, contest.id)); };
    var contestList = (_jsxs(_Fragment, { children: [_jsx(VisuallyHidden, { className: "contest-page-announcement", tabIndex: -1, ref: pageAnnouncementRef, children: t("a11y.stepOf", { current: pageIndex + 1, total: contests.length }) }), slateChooser && (sortedContests === null || sortedContests === void 0 ? void 0 : sortedContests.length) ? (_jsx(SlateOfficeNavigator, { contests: sortedContests, selection: ballotSelectionState, office: office, onOfficeChange: setOffice, renderContest: function (contest) {
                    return renderContest(contest, sortedContests.indexOf(contest));
                } })) : (sortedContests === null || sortedContests === void 0 ? void 0 : sortedContests.map(renderContest))] }));
    return (_jsxs(_Fragment, { children: [slateChooser ? (_jsxs(_Fragment, { children: [slateCount, _jsx(SlateBallotTabs, { value: slateTab, onChange: onSlateTabChange, slates: slateChooser, candidates: _jsxs(_Fragment, { children: [slateLabel, contestList] }) })] })) : (contestList), _jsx(ActionButtons, { handleNext: handleNext, handlePrev: handlePrev, handleClearCustom: slateChooser ? slateClear.requestClear : handleClear, disableClear: !!slateChooser && !slateClear.canClear, pageIndex: pageIndex, disableNext: disableNextButton(sortedContests) && contests.length !== 1 }), slateChooser ? slateClear.feedback : null] }));
};
var VotingScreen = function () {
    var _a, _b, _c, _d, _e, _f, _g;
    var _h = useTranslation(), t = _h.t, i18n = _h.i18n;
    var logout = useContext(AuthContext).logout;
    var canVote = useAppSelector(canVoteSomeElection());
    var electionId = useParams().electionId;
    var _j = useState({}), disableNext = _j[0], setDisableNext = _j[1];
    var _k = useState({}), decodedContests = _k[0], setDecodedContests = _k[1];
    var _l = useState(false), openBallotHelp = _l[0], setOpenBallotHelp = _l[1];
    var _m = useState(false), openNotVoted = _m[0], setOpenNonVoted = _m[1];
    var _o = useState(false), hasInvalidErrors = _o[0], setHasInvalidErrors = _o[1];
    var _p = useState([]), contestsPerPage = _p[0], setContestsPerPage = _p[1];
    var location = useLocation();
    var editContestId = getEditContestId(location.state);
    var _q = useState(), officeRequest = _q[0], setOfficeRequest = _q[1];
    var _r = useState(editContestId ? ESlateBallotTab.CANDIDATES : ESlateBallotTab.SLATES), slateTab = _r[0], setSlateTab = _r[1];
    var encryptAndStoreBallot = useEncryptBallotForReview().encryptAndStoreBallot;
    var election = useAppSelector(selectElectionById(String(electionId)));
    var ballotStyle = useAppSelector(selectBallotStyleByElectionId(String(electionId)));
    var defaultLanguageCode = (_c = (_b = (_a = election === null || election === void 0 ? void 0 : election.presentation) === null || _a === void 0 ? void 0 : _a.language_conf) === null || _b === void 0 ? void 0 : _b.default_language_code) !== null && _c !== void 0 ? _c : (_e = (_d = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml.election_event_presentation) === null || _d === void 0 ? void 0 : _d.language_conf) === null || _e === void 0 ? void 0 : _e.default_language_code;
    var electionDescription = translateFromPresentation(election, "description", i18n.language, {
        defaultLanguageCode: defaultLanguageCode,
    });
    var selectionState = useAppSelector(selectBallotSelectionByElectionId((_f = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.election_id) !== null && _f !== void 0 ? _f : ""));
    var backLink = useRootBackLink();
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var submit = useSubmit();
    var slates = useBallotStyleSlates(ballotStyle);
    var hasSlates = !!slates.resolved && slates.resolved.slates.length > 0;
    var onSetDisableNext = function (id) { return function (value) {
        var _a;
        setDisableNext(__assign(__assign({}, disableNext), (_a = {}, _a[id] = value, _a)));
    }; };
    var onSetDecodedContests = function (id) { return function (value) {
        setDecodedContests(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[id] = value, _a)));
        });
    }; };
    // if true, when the user clicks next, there will be a dialog
    // that doesn't allow to continue and forces the user to fix the issues
    var disableNextButton = function (contests) {
        if (contests === void 0) { contests = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml.contests; }
        return check_voting_not_allowed_next_bool(contests, decodedContests);
    };
    // if true, when the user click next, there will be a dialog that prompts
    // the user to confirm before going to the next screen
    var showNextDialog = function () {
        return check_voting_error_dialog_bool(ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml.contests, decodedContests);
    };
    // whole-ballot blank ballots are only meaningful for MULTIPLE_CONTESTS
    // elections, and only when the admin has opted into the policy - this is
    // distinct from each contest's own (pre-existing) blank_vote_policy
    var isBlankBallotsPolicyEnabled = function () {
        var _a, _b;
        var isMultiContest = ((_a = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml.election_event_presentation) === null || _a === void 0 ? void 0 : _a.contest_encryption_policy) ==
            EElectionEventContestEncryptionPolicy.MULTIPLE_CONTESTS;
        return (((_b = election === null || election === void 0 ? void 0 : election.presentation) === null || _b === void 0 ? void 0 : _b.blank_ballots_policy) === EBlankBallotsPolicy.ENABLED &&
            isMultiContest);
    };
    var isWholeBallotBlank = function () {
        var _a;
        // Acclaimed contests are never encoded and never blank, so a ballot is
        // wholly blank when every contest the voter could actually fill in is.
        var contests = ((_a = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml.contests) !== null && _a !== void 0 ? _a : []).filter(function (contest) { return !isAcclaimedContest(contest); });
        if (contests.length === 0 || !isBlankBallotsPolicyEnabled()) {
            return false;
        }
        return contests.every(function (contest) {
            var decoded = decodedContests[contest.id];
            return Boolean(decoded && checkIsBlank(decoded));
        });
    };
    var encryptAndReview = function () {
        if (isUndefined(selectionState) || !ballotStyle) {
            return;
        }
        else if (showNextDialog() || disableNextButton()) {
            setOpenNonVoted(true);
            var newHasInvalidErrors = Object.values(decodedContests).some(function (a) { return (a === null || a === void 0 ? void 0 : a.invalid_errors.length) > 0; });
            setHasInvalidErrors(newHasInvalidErrors);
        }
        else {
            finallyEncryptAndReview();
        }
        dispatch(setIsVoted(electionId));
    };
    var finallyEncryptAndReview = function () {
        var _a, _b;
        if (isUndefined(selectionState) || !ballotStyle) {
            return;
        }
        // A fully acclaimed election produces no ballot, so there is nothing
        // to encrypt: the voter reviews what was decided by acclamation and
        // moves on.
        if (areAllContestsAcclaimed(ballotStyle.ballot_eml.contests)) {
            return submit(null, { method: "post" });
        }
        dispatch(clearDeclinedToVoteForElection(ballotStyle.election_id));
        // dispatch() updates the Redux store synchronously, but the
        // `selectionState` bound in this closure was captured by
        // useAppSelector on a prior render and won't reflect it - re-read
        // the store directly, mirroring StartScreen.tsx's confirmDeclineToVote().
        var selectionStateToEncrypt = selectionState;
        if (isWholeBallotBlank()) {
            dispatch(setAllBallotSelectionsBlankBallot({ ballotStyle: ballotStyle }));
            selectionStateToEncrypt =
                (_a = selectBallotSelectionByElectionId(ballotStyle.election_id)(store.getState())) !== null && _a !== void 0 ? _a : selectionState;
        }
        var isMultiContest = ((_b = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml.election_event_presentation) === null || _b === void 0 ? void 0 : _b.contest_encryption_policy) ==
            EElectionEventContestEncryptionPolicy.MULTIPLE_CONTESTS;
        if (encryptAndStoreBallot(ballotStyle, selectionStateToEncrypt, isMultiContest)) {
            submit(null, { method: "post" });
        }
        else {
            submit({ error: VotingPortalErrorType.UNABLE_TO_CAST_BALLOT }, { method: "post" });
        }
    };
    useEffect(function () {
        if (!election || !ballotStyle) {
            navigate(backLink);
        }
        else if (!selectionState || !canVote) {
            logout();
        }
        else if (electionId) {
            dispatch(clearDeclinedToVoteForElection(electionId));
        }
    }, [
        navigate,
        backLink,
        election,
        ballotStyle,
        selectionState,
        canVote,
        logout,
        electionId,
        dispatch,
    ]);
    useEffect(function () {
        var _a, _b, _c;
        var minMaxGlobal = false;
        var contestsPages = new Map();
        var contests = sortContestsInBallotOrder((_a = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml.contests) !== null && _a !== void 0 ? _a : []);
        var _loop_1 = function (contest) {
            var countVotes = 0;
            var selection = selectionState === null || selectionState === void 0 ? void 0 : selectionState.find(function (s) { return s.contest_id === contest.id; });
            for (var _e = 0, _f = (_b = selection === null || selection === void 0 ? void 0 : selection.choices) !== null && _b !== void 0 ? _b : []; _e < _f.length; _e++) {
                var choice = _f[_e];
                if (choice.selected > -1) {
                    countVotes += choice.selected + 1;
                }
            }
            var outOfRange = countVotes < contest.min_votes || countVotes > contest.max_votes;
            minMaxGlobal = minMaxGlobal || outOfRange;
            // Calculate contests pagination using the pagination_policy string identifier
            var contestPageName = ((_c = contest.presentation) === null || _c === void 0 ? void 0 : _c.pagination_policy) || "";
            if (!contestsPages.has(contestPageName)) {
                contestsPages.set(contestPageName, []);
            }
            contestsPages.get(contestPageName).push(contest);
        };
        for (var _i = 0, _d = contests !== null && contests !== void 0 ? contests : []; _i < _d.length; _i++) {
            var contest = _d[_i];
            _loop_1(contest);
        }
        // A ballot with slates goes through its offices with the office
        // navigator instead of pages.
        var contestsAsArrays = hasSlates ? [contests] : Array.from(contestsPages.values());
        setContestsPerPage(contestsAsArrays);
        setDisableNext(function (state) { return (__assign(__assign({}, state), { minmax_global: minMaxGlobal })); });
    }, [selectionState, ballotStyle, hasSlates]);
    if (!ballotStyle || !election) {
        return _jsx(CircularProgress, { className: "voting-progress", "aria-label": t("a11y.loading") });
    }
    var warnAllowContinue = function (value) {
        setOpenNonVoted(false);
        if (value) {
            finallyEncryptAndReview();
        }
    };
    return (_jsx(BallotSlatesProvider, { slates: slates.config, children: _jsxs(PageLimit, { maxWidth: "lg", className: "voting-screen screen", children: [_jsx(Box, { marginTop: "48px", className: "stepper-box", children: _jsx(Stepper, { selected: 1 }) }), _jsxs(StyledTitle, { variant: "h4", component: "h1", className: "title-container screen-title", children: [_jsx(Box, { className: "selected-election-title", children: (_g = translateFromPresentation(election, "name", i18n.language, {
                                defaultLanguageCode: defaultLanguageCode,
                            })) !== null && _g !== void 0 ? _g : "-" }), _jsx(IconButton, { className: "title-question", buttonClassName: "screen-help-button", icon: faCircleQuestion, sx: { fontSize: "unset", lineHeight: "unset", paddingBottom: "2px" }, fontSize: "16px", onClick: function () { return setOpenBallotHelp(true); }, ariaLabel: t("a11y.helpAbout", {
                                topic: t("votingScreen.ballotHelpDialog.title"),
                            }) }), _jsx(Dialog, { className: "screen-help-dialog voting-help-dialog", handleClose: function () { return setOpenBallotHelp(false); }, open: openBallotHelp, title: t("votingScreen.ballotHelpDialog.title"), ok: t("votingScreen.ballotHelpDialog.ok"), variant: "info", children: stringToHtml(t("votingScreen.ballotHelpDialog.content")) })] }), electionDescription ? (_jsx(Typography, { className: "description screen-description", variant: "body2", component: "div", sx: { color: theme.palette.customGrey.main }, children: stringToHtml(electionDescription) })) : null, _jsx(ContestPagination, { slateChooser: hasSlates && slates.resolved ? (_jsx(SlateSelectionChooser, { ballotStyle: ballotStyle, slates: slates.resolved, defaultLanguage: defaultLanguageCode, onEditSelections: function (slate) {
                            var _a;
                            setSlateTab(ESlateBallotTab.CANDIDATES);
                            setOfficeRequest({ contestId: (_a = slate.contests[0]) === null || _a === void 0 ? void 0 : _a.contest.id });
                        } })) : undefined, slateCount: _jsx(SlateBallotCount, { ballotStyle: ballotStyle }), slateLabel: slates.resolved ? (_jsx(SlateSelectionLabel, { ballotStyle: ballotStyle, slates: slates.resolved, defaultLanguage: defaultLanguageCode })) : undefined, slateTab: slateTab, officeRequest: officeRequest, onSlateTabChange: setSlateTab, editContestId: editContestId, ballotStyle: ballotStyle, contests: contestsPerPage, onSetDisableNext: onSetDisableNext, onSetDecodedContests: onSetDecodedContests, encryptAndReview: encryptAndReview, disableNextButton: disableNextButton }), disableNextButton() ? (_jsx(Dialog, { className: "ballot-validation-dialog", handleClose: function (value) { return setOpenNonVoted(false); }, open: openNotVoted, title: t("votingScreen.nonVotedDialog.title"), ok: t("votingScreen.nonVotedDialog.ok"), variant: "softwarning", children: stringToHtml(t("votingScreen.nonVotedDialog.content")) })) : (_jsx(Dialog, { className: "ballot-validation-dialog", handleClose: function (value) { return warnAllowContinue(value); }, open: openNotVoted, title: t(hasInvalidErrors
                        ? "votingScreen.nonVotedDialog.title"
                        : isWholeBallotBlank()
                            ? "votingScreen.blankBallotDialog.title"
                            : "votingScreen.warningDialog.title"), ok: t(hasInvalidErrors
                        ? "votingScreen.nonVotedDialog.continue"
                        : isWholeBallotBlank()
                            ? "votingScreen.blankBallotDialog.continue"
                            : "votingScreen.warningDialog.continue"), cancel: t(hasInvalidErrors
                        ? "votingScreen.nonVotedDialog.cancel"
                        : isWholeBallotBlank()
                            ? "votingScreen.blankBallotDialog.cancel"
                            : "votingScreen.warningDialog.cancel"), variant: "action", children: stringToHtml(t(hasInvalidErrors
                        ? "votingScreen.nonVotedDialog.content"
                        : isWholeBallotBlank()
                            ? "votingScreen.blankBallotDialog.content"
                            : "votingScreen.warningDialog.content")) }))] }) }));
};
export default VotingScreen;
export function action(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var data, error, url, search;
        var request = _b.request;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, request.formData()];
                case 1:
                    data = _c.sent();
                    error = data.get("error");
                    if (error) {
                        throw new VotingPortalError(VotingPortalErrorType[error]);
                    }
                    url = new URL(request.url);
                    search = url.search || "";
                    return [2 /*return*/, redirect("../review".concat(search))];
            }
        });
    });
}
var templateObject_1, templateObject_2, templateObject_3;
